export const PUBLIC_ROUTES = ['/', '/:slug'];

export const AUTH_REQUIRED_ROUTES = ['/profile'];

export const GUEST_ONLY_ROUTES = ['/login', '/registration', '/forgot-password'];

export const LOGIN_REDIRECT_PATH = '/login';

export const LOGGED_IN_REDIRECT_PATH = '/profile';
